import Nav from "../Layout/Nav";
import "./Home.css";
import wecare1 from "../assets/wecare1.jpg";
import wecare2 from "../assets/wecarebg (2).png";
import rateimg from "../assets/rateimg.png";
import rimg from "../assets/review2.png";
import rimg2 from "../assets/myprofile.png";
import emoji from "../assets/emoji.png";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Rating } from "@mui/material";
import { Close, Handshake, Map, Star } from "@mui/icons-material";
import { Helmet } from "react-helmet";

const Home = () => {
  const [islogin, setislogin] = useState(false);
  const [user, setuser] = useState();
  // const [playvideo, setplayvideo] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [installPrompt, setinstallPrompt] = useState(null);
  const [showInstall, setShowInstall] = useState(false);
  const [profile, setprofile] = useState();
  const [screen, setscreen] = useState();

  const navigate = useNavigate();

  const schemaData = {
    "@context": "http://schema.org",
    "@type": "LocalBusiness",
    name: "i-Companion",
    address: {
      "@type": "PostalAddress",
      addressLocality: "California",
      addressRegion: "CA",
      postalCode: "90001",
      streetAddress: "123 Main St",
    },
    url: "https://i-companion.com/",
    telephone: "+1-555-555-5555",
    description:
      "i-Companion offers companionship care services for seniors, including in-home companion care and elderly companion services in California.",
  };

  useEffect(() => {
    const profileData = localStorage.getItem("data");
    const screenData = localStorage.getItem("screen");

    if (profileData && screenData) {
      setprofile(JSON.parse(profileData));
      setscreen(screenData);
    }

    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setinstallPrompt(event);
      setShowInstall(true);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
  }, []);

  useEffect(() => {
    const userToken = localStorage.getItem("ntk");
    if (userToken) {
      setislogin(true);
      profile?.user_type === "1" ? setuser(true) : setuser(false);
    } else {
      setislogin(false);
    }
  }, [profile]);

  const review = [
    {
      name: "Alishafa",
      pic: rimg,
      desc: "i-companion has been an invaluable support in caring for my loved one. Their dedication, compassion, and professionalism have made a significant difference in our lives.",
      star: 5,
    },
    {
      name: "Yousef",
      pic: rimg2,
      desc: "I highly recommend i-Companion for their exceptional caregiving services. Their companion brought immense joy and comfort to our loved one, making each day brighter.",
      star: 5,
    },
    // {
    //   name: "David H",
    //   pic: rimg,
    //   desc: "Choosing i-Companion for caregiving was one of the best decisions we made. The support and care provided by our companion were beyond our expectations.",
    //   star: 5,
    // },
  ];
  const handlePrevClick = () => {
    setActiveIndex((prevIndex) =>
      prevIndex === 0 ? review.length - 1 : prevIndex - 1,
    );
  };

  const handleNextClick = () => {
    setActiveIndex((prevIndex) =>
      prevIndex === review.length - 1 ? 0 : prevIndex + 1,
    );
  };
  const currentItem = review[activeIndex];

  const handleInstallClose = () => {
    setShowInstall(false);
  };

  const handleInstall = () => {
    if (installPrompt) {
      installPrompt.prompt();
      installPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
          console.log("User accepted the A2HS prompt");
        } else {
          console.log("User dismissed the A2HS prompt");
        }
        setinstallPrompt(null);
        setShowInstall(false);
      });
    }
  };

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          Companion Care Services for California Seniors | i-Companion
        </title>
        <link rel="canonical" href="https://i-companion.com/" />
        <meta
          name="description"
          content="	i-Companion offers trusted companion care services for California seniors. Discover how we provide compassionate, in-home companion care for elderly individuals."
        />
        <link rel="preload" as="image" href="../assets/landing_header.png" />
        <meta
          name="google-site-verification"
          content="sMbNX_0xhbBQ1PX2a3QTp1oXNKT-KX6xEPItn9Y9iTA"
        />
        <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
      </Helmet>

      {showInstall ? (
        <div id="install">
          <Close
            sx={{ color: "white", fontSize: "16px" }}
            onClick={handleInstallClose}
          />
          Get our free web app for seamless companion-client communication and
          booking
          <button onClick={handleInstall}>Install</button>
        </div>
      ) : (
        ""
      )}

      <section className="seaction1">
        <Nav />
        <div className="sec1data">
          {/* <h1 className="sec1title">
            Find the Perfect Companion for Your Loved One.
          </h1> */}
          <h1 className="sec1title">
            Welcome to i-Companion – Companion Care for California Seniors
          </h1>
          <p className="sec1det">
            Seniors face several challenges in old age, and at i-Companion we
            know better than anyone. In your later years, retaining
            independence, staying well-connected and receiving the right levels
            of support can be key to living life to the full. That's why we're
            pleased to provide Companion Care at home across California that
            supports the lives of older adults and allows them to remain in
            their homes{" "}
          </p>
          <p className="sec1know" onClick={() => navigate("/HowitWorks")}>
            Know More{" "}
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_34_305)">
                <path
                  d="M16.172 11H4V13H16.172L10.808 18.364L12.222 19.778L20 12L12.222 4.22198L10.808 5.63598L16.172 11Z"
                  fill="#312920"
                />
              </g>
              <defs>
                <clipPath id="clip0_34_305">
                  <rect
                    width="24"
                    height="24"
                    fill="white"
                    transform="matrix(-1 0 0 1 24 0)"
                  />
                </clipPath>
              </defs>
            </svg>
          </p>
          {islogin ? (
            user && screen === "5" ? (
              <button
                className="sec1caregiverbutton"
                onClick={() => navigate("/Booking_Type")}
              >
                Book Companion
              </button>
            ) : (
              ""
            )
          ) : (
            <>
              <button
                className="sec1caregiverbutton"
                onClick={() =>
                  navigate("/SignUpemail", {
                    state: {
                      type: "2",
                    },
                  })
                }
              >
                Sign Up as Companion
              </button>
              <button
                className="sec1clientbutton"
                onClick={() =>
                  navigate("/SignUpemail", {
                    state: {
                      type: "1",
                    },
                  })
                }
              >
                Sign Up as a Client
              </button>
            </>
          )}
          <div className="sec1emojidiv">
            <img
              src={emoji}
              alt="client happy"
              loading="lazy"
              width="45"
              height="45"
            />
            <a href="#testimonial">
              20+ <span>Happy Customers</span>
            </a>
          </div>
        </div>
      </section>
      <section className="section3">
        <h2 className="sec3title">You are in Good Hands</h2>
        <div className="sec3cardlist">
          <div className="sec3card">
            <div className="sec3cardsvg">
              <svg
                width="32"
                height="32"
                viewBox="0 0 45 45"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M44.7599 3.87675C44.7398 3.71068 44.6646 3.55614 44.5463 3.43785C44.428 3.31956 44.2735 3.24435 44.1074 3.22425C41.2738 2.87933 38.4046 2.96022 35.5949 3.46425C29.7981 4.458 24.0674 7.608 19.6244 11.9033C19.2141 12.2933 18.2354 13.218 17.8409 13.5968C15.5016 16.3005 12.8054 19.8818 11.2386 22.9118C11.0121 23.3708 11.2356 23.7195 11.6211 24.051C11.9804 24.411 12.6696 25.0928 13.5464 25.9695C16.8989 29.3295 20.5581 32.988 23.9339 36.3638L24.1889 36.6188C24.5436 36.9818 25.0506 36.819 25.4174 36.5588C27.7592 35.2513 29.9855 33.7468 32.0721 32.0618C40.5674 25.4085 46.2614 14.8058 44.7599 3.87675ZM35.0099 21.4875C31.3094 25.2713 24.6741 22.53 24.7349 17.2313C24.6861 11.9258 31.2869 9.189 35.0099 12.975C37.3626 15.3203 37.3626 19.1423 35.0099 21.4875ZM4.42639 24.9203C4.45639 24.9203 4.48639 24.9203 4.51639 24.9128L9.88939 24.2603C9.48964 23.5013 9.62839 22.5818 10.0994 21.87C10.4744 21.18 11.0886 20.124 11.9429 18.8273C13.3604 16.6178 15.1079 14.5065 16.7841 12.54L17.8634 11.5133C8.88214 11.4233 4.28464 19.3185 3.69214 24.0585C3.60589 24.4913 3.97789 24.9345 4.42639 24.9203ZM33.0164 33.2235C30.8626 34.9658 28.5635 36.5202 26.1441 37.8698C25.4534 38.3438 24.4881 38.5103 23.7239 38.0948L23.0714 43.4678C23.0076 43.8953 23.3751 44.3183 23.8139 44.3078C25.2291 44.1 31.6086 42.8198 34.8824 36.6863C35.9084 34.761 36.5099 32.1788 36.4784 30.1058C35.3808 31.206 34.2252 32.2467 33.0164 33.2235ZM19.8419 34.3928C17.6091 32.154 15.0381 29.586 12.8421 27.3855L12.3321 28.4205C12.123 28.8412 12.051 29.3169 12.1264 29.7807C12.2017 30.2444 12.4206 30.6729 12.7521 31.0058L16.9791 35.232C17.3111 35.5651 17.7396 35.785 18.2038 35.8604C18.668 35.9358 19.1441 35.8629 19.5644 35.652L20.5986 35.142C20.3481 34.893 20.1044 34.6448 19.8419 34.3928ZM12.8346 35.1795C7.65665 30.5723 3.07714 39.6593 3.00214 44.187C2.96314 44.6183 3.36364 45.0195 3.79714 44.982C8.31214 44.9063 17.3774 40.3523 12.8346 35.1795Z"
                  fill="white"
                />
                <path
                  d="M30.7529 12.7125C24.7964 12.8678 24.7596 21.5783 30.7529 21.75C36.7491 21.5745 36.7101 12.867 30.7529 12.7125Z"
                  fill="white"
                />
              </svg>
            </div>
            <h3>Our Mission</h3>
            <p>
              Our goal is simple; to deliver California Seniors care solution
              that exceeds every priority you have for your loved one's health,
              happiness and dignity. We believe in the strength of companionship
              thus our experienced team members work tirelessly so that seniors
              have an emotional, social, and practical support system.{" "}
            </p>
          </div>
          <div className="sec3card">
            <div className="sec3cardsvg">
              <svg
                width="30"
                height="34"
                viewBox="0 0 44 44"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_21_101)">
                  <path
                    d="M21.3623 34.7935C21.363 32.6187 21.9498 30.4844 23.0609 28.6149C24.1721 26.7454 25.7666 25.21 27.6766 24.1701C29.5866 23.1302 31.7416 22.6243 33.9149 22.7056C36.0881 22.787 38.1993 23.4525 40.0262 24.6323C40.0391 23.7359 40.046 22.7795 40.046 21.7473C40.046 16.4407 39.8655 13.1287 39.5089 9.69805H39.5596C39.3624 7.78639 38.6323 5.96853 37.4526 4.45147C36.2728 2.93442 34.6908 1.77913 32.8866 1.11719C32.7912 1.08109 32.6958 1.04672 32.5995 1.01406C31.8865 0.774393 31.1493 0.61387 30.4012 0.535391L30.3299 0.527656C27.4759 0.234609 27.0179 0 20.9997 0C14.9815 0 14.0078 0.234609 11.1564 0.531953L11.0851 0.539688C10.2998 0.622158 9.52663 0.795183 8.78108 1.05531V1.01664C6.92212 1.64869 5.28335 2.8005 4.05904 4.33553C2.83473 5.87056 2.07622 7.72444 1.87343 9.67742C1.51593 13.1149 1.33374 16.4304 1.33374 21.7473C1.33374 27.0643 1.51593 30.3798 1.87343 33.8173C2.11754 36.163 3.161 38.3534 4.8287 40.0209C6.49641 41.6885 8.68691 42.7317 11.0326 42.9756L11.104 42.9834C13.958 43.2807 14.4151 43.5153 20.4333 43.5153C22.4271 43.5153 23.8708 43.4895 25.0044 43.444C23.85 42.3186 22.933 40.9733 22.3075 39.4875C21.6819 38.0017 21.3605 36.4056 21.3623 34.7935ZM11.3076 11.4426H30.0687C30.6116 11.4426 31.1322 11.6582 31.5161 12.0421C31.9 12.426 32.1157 12.9467 32.1157 13.4896C32.1157 14.0325 31.9 14.5532 31.5161 14.9371C31.1322 15.321 30.6116 15.5366 30.0687 15.5366H11.3119C10.769 15.5366 10.2484 15.321 9.86447 14.9371C9.48058 14.5532 9.26491 14.0325 9.26491 13.4896C9.26491 12.9467 9.48058 12.426 9.86447 12.0421C10.2484 11.6582 10.769 11.4426 11.3119 11.4426H11.3076ZM11.3076 24.2962C10.7719 24.2853 10.2618 24.0647 9.88676 23.682C9.51175 23.2992 9.30171 22.7847 9.30171 22.2488C9.30171 21.7129 9.51175 21.1984 9.88676 20.8156C10.2618 20.4328 10.7719 20.2123 11.3076 20.2013H22.0077C22.2801 20.1957 22.5509 20.2446 22.8042 20.345C23.0575 20.4454 23.2882 20.5953 23.4828 20.786C23.6775 20.9766 23.8321 21.2042 23.9376 21.4554C24.0432 21.7066 24.0976 21.9763 24.0976 22.2488C24.0976 22.5213 24.0432 22.791 23.9376 23.0422C23.8321 23.2933 23.6775 23.5209 23.4828 23.7116C23.2882 23.9023 23.0575 24.0522 22.8042 24.1526C22.5509 24.253 22.2801 24.3018 22.0077 24.2962H11.3076Z"
                    fill="white"
                  />
                  <path
                    d="M33.4597 25.587C31.6388 25.587 29.8588 26.127 28.3448 27.1386C26.8308 28.1502 25.6508 29.5881 24.954 31.2704C24.2572 32.9526 24.0748 34.8037 24.4301 36.5896C24.7853 38.3755 25.6621 40.0159 26.9497 41.3035C28.2372 42.591 29.8777 43.4679 31.6636 43.8231C33.4494 44.1783 35.3006 43.996 36.9828 43.2992C38.6651 42.6024 40.103 41.4224 41.1146 39.9084C42.1262 38.3944 42.6661 36.6144 42.6661 34.7935C42.6661 32.3518 41.6962 30.0101 39.9696 28.2836C38.2431 26.557 35.9014 25.587 33.4597 25.587ZM37.1086 36.141H33.2766C32.986 36.141 32.7073 36.0256 32.5018 35.8201C32.2964 35.6146 32.1809 35.3359 32.1809 35.0453V29.1586C32.1809 28.868 32.2964 28.5893 32.5018 28.3838C32.7073 28.1783 32.986 28.0629 33.2766 28.0629C33.5672 28.0629 33.8459 28.1783 34.0514 28.3838C34.2569 28.5893 34.3723 28.868 34.3723 29.1586V33.9496H37.1086C37.3992 33.9496 37.6779 34.0651 37.8833 34.2705C38.0888 34.476 38.2043 34.7547 38.2043 35.0453C38.2043 35.3359 38.0888 35.6146 37.8833 35.8201C37.6779 36.0256 37.3992 36.141 37.1086 36.141Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_21_101">
                    <rect width="44" height="44" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <h3>Our History</h3>
            <p>
              Committed to providing quality care services in a straightforward
              and compassionate manner. By prioritizing the needs of both care
              seekers and caregivers (companions), we strive to create a safe,
              supportive, and respectful environment for all.
            </p>
          </div>
          <div className="sec3card">
            <div className="sec3cardsvg">
              <svg
                width="39"
                height="32"
                viewBox="0 0 50 44"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.6096 29.4297L19.3902 28.3424C20.0127 28.7206 20.706 29.0042 21.4387 29.1933L21.9272 31.2261H24.7005L25.189 29.1933C25.9217 29.0042 26.6072 28.7206 27.2296 28.3424L29.0181 29.4297L30.9799 27.4679L29.8927 25.6873C30.263 25.057 30.5545 24.3715 30.7357 23.6388L32.7684 23.1503V20.377L30.7357 19.8885C30.5545 19.1558 30.263 18.4703 29.8927 17.84L30.9799 16.0594L29.0181 14.0976L27.2296 15.1848C26.5932 14.8059 25.9061 14.5193 25.189 14.3339L24.7005 12.3091H21.9272L21.4387 14.3339C20.706 14.523 20.0127 14.8067 19.3902 15.1848L17.6096 14.0976L15.6399 16.0594L16.7351 17.84C16.3569 18.4703 16.0733 19.1558 15.8842 19.8885L13.8514 20.377V23.1503L15.8842 23.6388C16.0733 24.3715 16.3569 25.057 16.7351 25.6873L15.6399 27.4679L17.6096 29.4297ZM23.3217 18.2733C25.252 18.2733 26.812 19.8333 26.812 21.7636C26.812 23.7018 25.252 25.2618 23.3217 25.2618C21.3836 25.2618 19.8236 23.6939 19.8236 21.7636C19.8157 19.8412 21.3836 18.2733 23.3217 18.2733ZM41.4193 13.2861C44.9805 13.2861 47.8642 10.4024 47.8642 6.84121C47.8642 3.28 44.9805 0.396362 41.4193 0.396362C37.8581 0.396362 34.9745 3.28 34.9745 6.84121C34.9745 10.4024 37.8581 13.2861 41.4193 13.2861ZM38.5278 6.77818C38.6007 6.70514 38.6873 6.6472 38.7826 6.60766C38.8779 6.56812 38.9801 6.54777 39.0833 6.54777C39.1864 6.54777 39.2886 6.56812 39.3839 6.60766C39.4792 6.6472 39.5658 6.70514 39.6387 6.77818L40.3005 7.44788L43.1842 4.56424C43.3315 4.41693 43.5313 4.33416 43.7396 4.33416C43.948 4.33416 44.1478 4.41693 44.2951 4.56424C44.4424 4.71156 44.5252 4.91136 44.5252 5.1197C44.5252 5.32803 44.4424 5.52783 44.2951 5.67515L40.852 9.11818C40.7024 9.26788 40.5054 9.34667 40.2927 9.34667C40.0799 9.34667 39.883 9.26 39.7333 9.11818L38.5121 7.89697C38.2205 7.5897 38.2205 7.08545 38.5278 6.77818ZM7.34356 35.7012C7.05205 35.3703 6.78417 35.0158 6.51629 34.6691H0.575684V41.4055H15.3327C12.2609 40.1537 9.52487 38.2001 7.34356 35.7012Z"
                  fill="white"
                />
                <path
                  d="M49.4242 38.0255L42.9479 32.4709V34.6612H23.3139C20.7927 34.6612 18.4527 33.9285 16.4673 32.6679C12.843 30.383 10.4164 26.357 10.4164 21.7715C10.4164 17.1703 12.843 13.1442 16.4752 10.8594C18.4527 9.60666 20.8006 8.87394 23.3139 8.87394C30.4285 8.87394 36.2115 14.6491 36.2115 21.7715C36.2115 26.6327 33.4933 30.8794 29.4988 33.0776H39.3473C41.6164 29.8788 42.9479 25.9709 42.9479 21.7715C42.9479 19.3291 42.4988 16.997 41.6794 14.8382C41.5927 14.8382 41.5061 14.8539 41.4115 14.8539C36.9915 14.8539 33.3909 11.2612 33.3909 6.83333C33.3909 6.21879 33.4697 5.62788 33.5958 5.05272C30.6018 3.20121 27.08 2.13757 23.3061 2.13757C12.4806 2.13757 3.67212 10.9382 3.67212 21.7715C3.67212 26.6958 5.50788 31.2103 8.51757 34.6612C12.1261 38.7818 17.4127 41.3976 23.3061 41.3976H42.94V43.5958L49.4242 38.0255Z"
                  fill="white"
                />
              </svg>
            </div>
            <h3>Our Method</h3>
            <p>
              Uniting technology and companionship care to foster Care Sharing.
              Through our technology-driven approach, we connect companions with
              care seekers. {" "}
            </p>
          </div>
        </div>
      </section>
      <section className="section4">
        <div className="sec4data">
          <h2>Our services are designed to support you</h2>
          {/* <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam
            viverra mi quis lectus efficitur, sed accumsan diam mollis.
          </p> */}
          <div className="sec4supports">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_21_115)">
                <path
                  d="M12.375 2.25C14.6535 2.25 16.5 4.125 16.5 6.75C16.5 12 10.875 15 9 16.125C7.125 15 1.5 12 1.5 6.75C1.5 4.125 3.375 2.25 5.625 2.25C7.02 2.25 8.25 3 9 3.75C9.75 3 10.98 2.25 12.375 2.25Z"
                  fill="#825735"
                />
              </g>
              <defs>
                <clipPath id="clip0_21_115">
                  <rect width="18" height="18" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <p>
              <strong>Caring Staff:</strong> Our team of experienced and
              compassionate caregivers is devoted to enriching the lives of
              seniors in our community. We take a thoughtful and personalized
              approach, carefully matching each client with a caregiver who best
              fits their individual needs, preferences, and personality.
            </p>
          </div>
          <div className="sec4supports">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_21_115)">
                <path
                  d="M12.375 2.25C14.6535 2.25 16.5 4.125 16.5 6.75C16.5 12 10.875 15 9 16.125C7.125 15 1.5 12 1.5 6.75C1.5 4.125 3.375 2.25 5.625 2.25C7.02 2.25 8.25 3 9 3.75C9.75 3 10.98 2.25 12.375 2.25Z"
                  fill="#825735"
                />
              </g>
              <defs>
                <clipPath id="clip0_21_115">
                  <rect width="18" height="18" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <p>
              <strong>Home Care:</strong> For many seniors, remaining in the
              comfort of their own home is the key to maintaining independence
              and well-being. Our in-home companion care allows them to continue
              living where they feel most secure while receiving the assistance
              and support they need.
            </p>
          </div>
          <div className="sec4supports">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_21_115)">
                <path
                  d="M12.375 2.25C14.6535 2.25 16.5 4.125 16.5 6.75C16.5 12 10.875 15 9 16.125C7.125 15 1.5 12 1.5 6.75C1.5 4.125 3.375 2.25 5.625 2.25C7.02 2.25 8.25 3 9 3.75C9.75 3 10.98 2.25 12.375 2.25Z"
                  fill="#825735"
                />
              </g>
              <defs>
                <clipPath id="clip0_21_115">
                  <rect width="18" height="18" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <p>
              <strong> Customized Care Plans : </strong>Whether you need
              part-time, full-time, or around-the-clock support, we provide
              flexible care plans tailored to your loved one’s unique situation.
              We proudly serve California seniors and adapt our services to meet
              changing needs.
            </p>
          </div>
          <div className="sec4supports">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_21_115)">
                <path
                  d="M12.375 2.25C14.6535 2.25 16.5 4.125 16.5 6.75C16.5 12 10.875 15 9 16.125C7.125 15 1.5 12 1.5 6.75C1.5 4.125 3.375 2.25 5.625 2.25C7.02 2.25 8.25 3 9 3.75C9.75 3 10.98 2.25 12.375 2.25Z"
                  fill="#825735"
                />
              </g>
              <defs>
                <clipPath id="clip0_21_115">
                  <rect width="18" height="18" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <p>
              <strong>Individualized Attention:</strong> Every senior has their
              own lifestyle, challenges, and goals. We take the time to truly
              understand each person so we can provide companion care that is
              meaningful, respectful, and personalized.
            </p>
          </div>
          <div className="sec4supports">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_21_115)">
                <path
                  d="M12.375 2.25C14.6535 2.25 16.5 4.125 16.5 6.75C16.5 12 10.875 15 9 16.125C7.125 15 1.5 12 1.5 6.75C1.5 4.125 3.375 2.25 5.625 2.25C7.02 2.25 8.25 3 9 3.75C9.75 3 10.98 2.25 12.375 2.25Z"
                  fill="#825735"
                />
              </g>
              <defs>
                <clipPath id="clip0_21_115">
                  <rect width="18" height="18" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <p>
              Our caregivers do more than assist with daily living; they
              encourage activities that nurture the mind, body, and spirit. We
              believe true companionship is built on genuine connection and a
              caring presence.{" "}
            </p>
          </div>

          <button onClick={() => navigate("/Companion-Care-Service")}>
            Know More
          </button>
        </div>
        <div className="sec4divsimg">
          <div className="sec4imgs">
            <img
              width="320"
              height="373"
              src={wecare1}
              alt="companion care at home"
              loading="lazy"
            />
            <img
              height="373"
              width="320"
              src={wecare2}
              alt="companion Home care"
              loading="lazy"
            />
          </div>
          <img
            src={rateimg}
            alt="rate"
            className="sec4rateimg"
            loading="lazy"
            width="150"
            height="76"
          />
        </div>
      </section>

      <section className="section6">
        <h2 className="sec6title">Our Core Services</h2>
        <p className="sec6des">
          At i-Companion, we offer personalized companion care in home services
          for California seniors, addressing their unique needs:{" "}
        </p>
        <div className="sec6cardlist">
          <div className="sec6card">
            Companionship: Our caregivers provide regular interaction, offering
            conversation, games, and friendly company to combat loneliness and
            improve mental well-being.
          </div>
          <div className="sec6card">
            Errand Assistance: We assist with everyday tasks like grocery
            shopping and prescription pickups, helping seniors maintain their
            routines.{" "}
          </div>
          <div className="sec6card">
            Meal Preparation: Our caregivers plan, prepare, and serve nutritious
            meals tailored to seniors' dietary needs for better health.
          </div>
          <div className="sec6card">
            Transportation: We offer transportation to medical appointments,
            social outings, and other activities, promoting physical activity
            and social engagement.
          </div>
        </div>
      </section>

      <section className="section5" id="testimonial">
        <h2 className="sec5_title">
          What Clients Love About
          <br /> Our Companions
        </h2>
        <div className="sec5_card">
          <div className="sec5card_data">
            {" "}
            <h3>{currentItem.name}</h3>
            <p className="sec5_reviews">{currentItem.desc} </p>
            <Rating
              name="read-only"
              value={currentItem.star}
              readOnly
              size="small"
              style={{ gap: "3px" }}
            />
          </div>
          <img
            src={currentItem.pic}
            alt="Companion Care at Home"
            className="sec5_profilepic"
            loading="lazy"
          />
        </div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="42"
          height="42"
          viewBox="0 0 40 40"
          fill="none"
          onClick={handlePrevClick}
          className="previmgslider"
        >
          <circle
            cx="19.5"
            cy="19.5"
            r="19.1321"
            fill="var(--black)"
            stroke="var(--black)"
            strokeWidth="0.735849"
          />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            x="25%"
            y="25%"
          >
            <g clipPath="url(#clip0_103_446)">
              <path
                d="M11.8282 12L14.6572 9.172L13.2432 7.757L9.00023 12L13.2432 16.243L14.6572 14.828L11.8282 12Z"
                fill="var(--sec3cardbg)"
              />
            </g>
            <defs>
              <clipPath id="clip0_103_446">
                <rect
                  width="24"
                  height="24"
                  fill="white"
                  transform="matrix(-1 0 0 1 24 0)"
                />
              </clipPath>
            </defs>
          </svg>
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="42"
          height="42"
          viewBox="0 0 40 40"
          fill="none"
          onClick={handleNextClick}
          className="previmgslider"
        >
          <circle
            cx="19.5"
            cy="19.5"
            r="19.1321"
            fill="var(--black)"
            stroke="var(--black)"
            strokeWidth="0.735849"
          />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            x="25%"
            y="25%"
          >
            <g clipPath="url(#clip0_103_449)">
              <path
                d="M12.1718 12L9.34277 9.172L10.7568 7.757L14.9998 12L10.7568 16.243L9.34277 14.828L12.1718 12Z"
                fill="var(--sec3cardbg)"
              />
            </g>
            <defs>
              <clipPath id="clip0_103_449">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </svg>

        {/* <div className="arrow">
            <div className="leftr">
              <KeyboardArrowLeftIcon />
            </div>
            <div className="rightr">
              <KeyboardArrowRightIcon />
            </div>
          </div> */}
      </section>
      <section className="modern-section">
        <div className="circle-1 decoration"></div>
        <div className="circle-2 decoration"></div>
        <div className="dots decoration"></div>
        <div className="dots dots-2 decoration"></div>

        <div className="section-container">
          <div className="section-header">
            <h2 className="sec5_title">Companion Care Excellence</h2>
          </div>

          <div className="cards-container">
            <div className="feature-card">
              <div className="card-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="lucide lucide-handshake-icon lucide-handshake"
                >
                  <path d="m11 17 2 2a1 1 0 1 0 3-3" />
                  <path d="m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4" />
                  <path d="m21 3 1 11h-2" />
                  <path d="M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3" />
                  <path d="M3 4h8" />
                </svg>{" "}
              </div>
              <div className="card-content">
                <h3 className="card-title">What Is Companion Care at Home?</h3>
                <p className="card-description">
                  Our home companion services provide personalized non-medical
                  care that enables seniors to remain independent while staying
                  safe at home. We enhance quality of life through
                  companionship, emotional support, and assistance with daily
                  living activities.
                </p>
                <p className="card-description">
                  Our caregivers help with everything from minor housekeeping
                  and meal preparation to engaging conversations and
                  personalized activities tailored to each senior's interests.
                </p>
              </div>
            </div>

            <div className="feature-card">
              <div className="card-icon">
                <Star />
              </div>
              <div className="card-content">
                <h3 className="card-title">The i-Companion Difference</h3>
                <p className="card-description">
                  At i-Companion, we understand that exceptional care stems from
                  meaningful relationships. Beyond tasks, our caregivers become
                  trusted companions and advocates for your loved ones.
                </p>
                <p className="card-description">
                  We pledge to provide whole-person care that addresses not only
                  physical health but emotional and social well-being, creating
                  a comprehensive support system for California seniors.
                </p>
              </div>
            </div>

            <div className="feature-card highlighted-card">
              <div className="card-icon">
                <Map />
              </div>
              <div className="card-content">
                <h3 className="card-title">
                  Begin Your Journey with Our Companion Care
                </h3>
                <p className="card-description">
                  Starting with i-Companion is simple. Contact us to schedule a
                  consultation, and we'll collaborate to create a tailored care
                  plan that perfectly suits your loved one's unique needs.
                </p>
                <p className="card-description">
                  Whether you're arranging home companion care for a family
                  member or exploring services for yourself, i-Companion is
                  ready to assist. Our dedication to compassionate, high-quality
                  care has established us as California's trusted senior care
                  provider.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Home;
